module.exports = __webpack_public_path__ + "sprite/win-sign.json";


//////////////////
// WEBPACK FOOTER
// ./sprite/win-sign.json
// module id = 129
// module chunks = 3